// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
// AFP-2532 TODO: Fix automatic suppressions below
// https://product-fabric.atlassian.net/browse/AFP-2532
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AccordionToggleButton = styled.button({
	textAlign: 'left',
	cursor: 'pointer',
	padding: token('space.200', '16px'),
	width: '100%',
	background: 'none',
	border: 'none',
	'@supports selector(*:focus-visible)': {
		'&:focus': {
			boxShadow: 'none',
		},
		'&:focus-visible': {
			outline: 'none',
			transform: 'translateZ(0)',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			boxShadow: `0px 0px 0px 2px ${token('color.border.focused', colors.B100)}`,
		},
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ChecklistTitleWrapper = styled.div({
	position: 'relative',
	padding: `0 ${token('space.500', '40px')}`,
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ChecklistTaskDoneIndicator = styled.div`
	display: block;
	width: ${token('space.300', '24px')};
	height: ${token('space.300', '24px')};
	color: ${(props: { done: boolean }) =>
		props.done ? token('color.icon.success', colors.G300) : token('color.icon.subtle', colors.N40)};
	position: absolute;
	left: 0;
	top: 50%;
	border-radius: 12px;
	transform: translateY(-50%);
`;

export const checklistClosedIndicator = (
	animationDuration: number,
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
) => styled.div`
	display: block;
	width: ${token('space.300', '24px')};
	height: ${token('space.300', '24px')};
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);

	& > span {
		transform: ${(props: { expanded: boolean }) =>
			props.expanded ? 'rotate(-90deg)' : 'rotate(90deg)'};
		transition: transform ${animationDuration}ms;
	}
`;
